import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    servicesList: {
        display: 'flex',
        justifyContent: 'flex-start',
        flexWrap: 'wrap',
        '@media (max-width:595px)': {
            justifyContent: 'center',
        },
    },
    catalogueLetter: {
        fontSize: '1.5rem',
        fontWeight: '600',
        textAlign: 'center',
        color: '#2E2E2E',
        padding: '16px 16px 10px 24px',
        marginTop: '0px',
        width: '16px',
        '@media (max-width:600px)': {
            paddingBottom: '0px',
        },
    },
    serviceGroup: {
        background: 'rgba(224, 244, 253, 0.15)',
        border: '1px solid #E0F4FD',
        boxSizing: 'border-box',
        borderRadius: '3px',
        marginTop: '16px',
        padding: '14px 16px 14px 0px',
        '@media (max-width:600px)': {
            width: '95%',
            marginTop: '0px',
            paddingRight: '0px',
        },
    },
}));

const CatalogueList = ({ services, letter, letterIndex }) => {
    const classes = useStyles();

    return (
        <div className={classes.servicesList}>
            <div style={{ float: 'left' }}>
                <h2 className={classes.catalogueLetter} key={letterIndex}>
                    {letter}
                </h2>
            </div>
            <div style={{ float: 'left' }} className={classes.serviceGroup}>
                {services}
            </div>
        </div>
    );
};

export default CatalogueList;
